export const cmsApiUrl = process.env.REACT_APP_CMS_API;
export const cmsSuperAppApiUrl = process.env.REACT_APP_CMS_SUPER_APP_API;
export const essoApiUrl = process.env.REACT_APP_ESSO_API;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const CLIENT_APP_ID = process.env.REACT_APP_CLIENT_APP_ID;
export const DEFAULT_TABLE_ITEM_SIZE = 10;

// Datetime format
export const DATE_FORMAT_DISPLAY = 'DD/MM/YYYY';
export const DATE_FORMAT_VALUE = 'YYYY-MM-DD';
export const DATETIME_FORMAT_VALUE = 'YYYY-MM-DD hh:mm:ss';
export const DATETIME_FORMAT_DISPLAY = 'DD/MM/YYYY HH:mm:ss';

export const storageKeys = {
    ACCESS_TOKEN: process.env.REACT_APP_ACCESS_TOKEN_KEY,
    REFRESH_TOKEN: process.env.REACT_APP_REFRESH_TOKEN_KEY,
}

export const fieldTypes = {
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    SELECT: 'SELECT',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
    DATE: 'DATE',
    UPLOAD: 'UPLOAD',
    RADIO: 'RADIO',
    BOOLEAN: 'BOOLEAN',
    CHECKBOX: 'CHECKBOX'
}

export const commonStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    LOCK: 'LOCK'
}

export const userRoles = {
    ADMIN: 'ADMIN',
    ACCOUNTANT: 'ACCOUNTANT',
}

export const productAttributeInputTypes = {
    DROPDOWN: 'DROPDOWN',
    MULTISELECT: 'MULTISELECT',
    PLAIN_TEXT: 'PLAIN_TEXT',
    RICH_TEXT: 'RICH_TEXT',
}

export const currencyTypes = {
    VND: 'VND',
}

export const statusTypes = {
    SUBMITTED: 'SUBMITTED',
    SUBMIT_FAILED: 'SUBMIT_FAILED',
    SENT: 'SENT',
    SEND_FAILED: 'SEND_FAILED',
}

export const appConfigKeys = {
    SMS_VIETGUYS: 'SMS_VIETGUYS',
}

export const appPlatforms = {
    EDUFUN: 'EDUFUN',
}


export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export const phoneRegExp = /^(84([3|5|7|8|9]([0-9]{8}))|0([3|5|7|8|9]([0-9]{8}))|02[0-9]{1}([0-9]{8}))$/;
export const passwordRegex = /^[-a-zA-Z0-9-~!@#$%^&*()+/?\\_`=;:"'><.,|{}[\]]+(\s+[-a-zA-Z0-9-~!@#$%^&*()+/?\\_`=;:"'><.,|{}[\]]+)*$/;
export const whiteSpaceRegex = /^[^\s]+(\s+[^\s]+)*$/g;
